import React, { useEffect, useState } from "react";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import {AddUserPostApi, getColorListAPI, getVehicleListApi } from "../../../../Api/PanelAdminServices";
import Style from "./AddDeliveryContainer.module.scss";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import '../AddSupplierContainer/AddSupplier.css'
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";

const AddDeliveryContainer = () => {
  const [photo, setPhoto] = useState("");
  const [chooseCity, setChooseCity] = useState();
  const [disable, setDisable] = useState(false);
  const [ColorListState, setColorListState] = useState([]);
  const [VehicleListState, setVehicleListState] = useState([]);
  const [chooseColor, setChooseColor] = useState();
  const [chooseVehical, setChooseVehical] = useState();
  const city = [
    {
      value: "1",
      label: "بهشهر",
      cityId:"4851"
    },
    {
      value: "2",
      label: "گلوگاه",
      cityId:"4861"
    },
    {
      value: "3",
      label: "نکا",
      cityId:"4841"
    },
  ];
  useEffect(()=>{
    getDataHandler()
  },[])
  const getDataHandler=()=>{
    getColorListAPI((succ,res)=>{
      if(succ){
        if(res.status===1){
          setColorListState(res.colors)
        }else{
          errorToast(res.message)
        }
      }else{
        console.log(res)
      }
    })
    getVehicleListApi((succ,res)=>{
      if(succ){
        if(res.status===1){
          setVehicleListState(res.models)
        }else{
          errorToast(res.message)
        }
      }else{
        console.log(res)
      }
    })
  }
  let colorList=[]
  ColorListState.forEach(element => {
    colorList.push({
      value:element.id,
      label:element.color,
    })
  });
  let vehicleListArray=[]
  VehicleListState.forEach(element => {
    vehicleListArray.push({
      value:element.id,
      label:element.model,
    })
  });

  //////آپلود کردن عکس 
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    setDisable(true)
    let info = {
      first_name: data.name,
      last_name: data.lName,
      phone: data.phone,
      national_code: data.nationalcode,
      email: data.email? data.email:"",
      city_id:chooseCity.cityId,
      user_type: "deliver",
      photo:photo,
      vehicle_color:chooseColor.value,
      vehicle_model:chooseVehical.value,
      vehicle_plate:data.vehicle_plate,
      vehicle_type:"sedan",
    };
    AddUserPostApi(info, (res) => {
      if(res.status===1){
        succToast(res.message)
        setDisable(false)
      }else{
        errorToast(res.message)
        setDisable(false)
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"افزودن پیک "} />
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>

          <section className={Style.logoPart}>
            <div className={Style.titleLogo}>بارگذاری تصویر</div>
            <div className={Style.uploadImage}>
              <img src={photo} alt="" />
            </div>
            <input
              id={"uploadPhoto"}
              type="file"
              style={{ display: "none" }}
              onChange={(e) => UploadPhoto(e.target.files[0])}
            />
            <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
              <FontAwesomeIcon className={Style.icon} icon={faImage} />
            </label>
            <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
          </section>

          <input
            className={errors.name ? Style.errorInput : Style.inputPart}
            placeholder={"نام"}
            {...register("name", { required: true })}
          />

          <input
            className={errors.lName ? Style.errorInput : Style.inputPart}
            placeholder={"نام خانوادگی "}
            {...register("lName", { required: true })}
          />

          <Select
            onChange={setChooseCity}
            options={city}
            placeholder={" شهر"}
            className={Style.selectPart}
          />
          <input
            className={errors.phone ? Style.errorInput : Style.inputPart}
            placeholder={"شماره همراه"}
            {...register("phone", { required: true })}
          />
          <input
            className={Style.inputPart}
            placeholder={"ایمیل "}
            {...register("email")}
          />
          <input
            className={errors.nationalcode ? Style.errorInput : Style.inputPart}
            placeholder={"کدملی "}
            {...register("nationalcode", { required: true })}
          />
          <Select
            onChange={setChooseVehical}
            options={vehicleListArray}
            placeholder={" مدل وسیله نقلیه"}
            className={Style.selectPart}
          />
          <Select
            onChange={setChooseColor}
            options={colorList}
            placeholder={" رنگ وسیله نقلبه"}
            className={Style.selectPart}
          />
                    <input
            className={errors.vehicle_plate ? Style.errorInput : Style.inputPart}
            placeholder={"پلاک ماشین "}
            {...register("vehicle_plate", { required: true })}
          />

          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            اضافه کردن
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddDeliveryContainer